import { Component, OnInit } from '@angular/core';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SubjectLetterService } from 'src/app/Service/SubjectLetter/SubjectLetter.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-LetterRequestCustomerReport',
  templateUrl: './LetterRequestCustomerReport.component.html',
  styleUrls: ['./LetterRequestCustomerReport.component.css']
})
export class LetterRequestCustomerReportComponent implements OnInit {
  page: number = 0;
  page2: number = 0;
  Procssing: boolean = false

  Filter_customer: String = ''
  StartSearchDate: String = ''
  EndSearchDate: String = ''
  LetterType_Filter: String = '0'
  DeviceName_Filter: String = ''
  LetterNumber_Filter: String = ''
  SubmitPeriodDate:string='1'

  constructor(
    private Nav_Service: NavService,
    private SubjectLetter_Service: SubjectLetterService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
  ) { }

  ngOnInit() {

    this.Nav_Service.CheckValidPage(2233).subscribe(
      data => {
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

  DataList_LetterRequestCustomer: Array<LetterRequestCustomer_List_Interface> = []
  DataList_Sum:number=0
  DataList_Count:number=0
  ReadData_Customer(StartSearchDate, EndSearchDate) {
    this.Procssing = true
    this.DataList_LetterRequestCustomer=[]
    this.DataList_LetterRequestCustomer=[]


    this.LetterRequestCustomer_Service.GetLetterRequestCustomerReport(
      StartSearchDate,
      EndSearchDate,
      Number(this.LetterType_Filter),
      this.Subject_Filter,
      Number(this.SubmitPeriodDate),
      this.DeviceName_Filter,
      this.LetterNumber_Filter).subscribe(
        data => {
          this.DataList_LetterRequestCustomer = data['result']
          this.DataList_Sum = data['sum']
          this.DataList_Count = data['count']

          this.Procssing = false
        }
      )
  }


  Subject_Filter:String=''
  OnGet_SubjectLetter_Action(model: Array<General_Interface>)
  {
    this.Subject_Filter = "-1"
    for (let item of model)
    {
      this.Subject_Filter=this.Subject_Filter+","+item.id
    }

    if (model.length == 0)
      this.Subject_Filter=""

  }

    exportexcel(): void {
      /* table id is passed over here */
      let element = document.getElementById('excel-table');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, "BehfaLetter.xlsx");
  
    }

}
